const nl = {

    message: {

        title1: 'Afstandsbediening van smart home, technologie, veiligheid en gemoedsrust',

        content1:' AigoSmart helpt u bij het op afstand beheren en besturen van slimme huishoudelijke apparaten, en de apparaten kunnen elkaar ook waarnemen en linken. Met één klik kunnen verschillende huishoudelijke apparaten in uw vooraf ingestelde status gaan, waardoor u een veilig en zorgeloos slim huis voor u kunt creëren leven',

        title2:"AigoSmart is een nieuw submerk van Aigostar",

        content2:"De producten worden momenteel verkocht aan Spanje, Portugal, Frankrijk, Italië, Nederland, Duitsland, Finland, Denemarken, Polen, Rusland, Griekenland, Oostenrijk, Zwitserland, Tsjechië, Hongarije, Slowakije en andere Europese landen en regio's",

        content3:" AIGOSTAR's verschillende keuken-, was- en strijkmachines blijven kleine huishoudelijke apparaten bezetten",

        content4:" Top tien verkopen.",

        title3:"Brand Honour",

        content5:"Snel. Open. Innoveren. Volhouden",

        loading: 'Laden',

        submit: 'Verzenden',

        contactUs:"Neem contact met ons op",

        privacy:"Privacyovereenkomst",

        policy:"Servicebeleid",

        download:"Download",



    },

}



export default nl;